<template lang="html">

  <section class="-home">

    <!--     <div class="contenedor-video-home">
      <router-link to="/tomarelleno">
        <video playsinline="true" autoplay muted id="video" poster="/static/img/momento-ganador/frame-video-tres.jpg">
          <source src="/static/img/momento-ganador/video-tres.mp4" type="video/mp4">
        </video>
      </router-link>
    </div> -->
    <!-- <router-link to="/tomarelleno" class="btn-enviar -enviar-pink">{{$t('generales.participar')}}</router-link> -->
    <!--     <div class="contenedor-banner-botones">
      <div class="banner-botones">
        <router-link v-for="(n,key) in 5" :key="key" to="/tomarelleno" class="btn-enviar -enviar-pink">{{$t('generales.participar')}}</router-link>
      </div>
    </div> -->
    <div class="main-banner">
      <a href="https://tienda.fiesta.es/es/caramelos-con-palo/278-fresquito-pollo-kfc--8411402290975.html"
        target="_blank" rel="noopener noreferrer">
        <img src="/static/img/banners/BannerFresquitoKFC.jpg" alt="Banner Fresquito KFC" />
      </a>
    </div>
    <banner-marcas class="banner-marca-home"></banner-marcas>
    <banner-novedades></banner-novedades>
    <banner-historia></banner-historia>
    <banner-curiosidades></banner-curiosidades>
  </section>

</template>

<script lang="js">

import bannerCuriosidades from '@/components/parts/banner-curiosidades';
import bannerMarcas from '@/components/parts/banner-marcas-home';
import bannerNovedades from '@/components/parts/banner-novedades';
import bannerHistoria from '@/components/parts/banner-historia';

export default {
  name: 'home',
  components: {
    'banner-curiosidades': bannerCuriosidades,
    'banner-marcas': bannerMarcas,
    'banner-novedades': bannerNovedades,
    'banner-historia': bannerHistoria,
  },
  data() {
    return {
      video: 1
    }
  },
  methods: {
    nextvideo() {
      if (this.video < 3) {
        this.video++;
      } else {
        this.video = 1;
      }

      setTimeout(e => {

        var video = document.getElementById('video');

        video.pause();
        video.load();
        video.play();
      }, 200)

    }
  }
}
</script>


<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/views/home.vue